module.exports = __webpack_public_path__ + "static/img/mzsm_font.31ed80f4.svg";